/* eslint-disable import/prefer-default-export */

/**
 * returns current page URL without any query params or fragment identifier.
 *
 * the .origin property on window.location is not available everywhere (notably
 * IE11), so we have to construct it manually.
 *
 *  @param {Object} winLoc location object
 *  @param {String} winLoc.protocol
 *  @param {String} winLoc.hostname
 *  @param {String} winLoc.port
 *  @param {String} path
 *  @returns {String} current page URL
 */
export function getCurrentWindowUrl(winLoc, path) {
  const { protocol, hostname, port } = winLoc;
  return `${protocol}//${hostname}${port ? `:${port}` : ''}${path}`;
}
